import DeliveryFrequencyModal from 'components/GlobalModals/DeliveryFrequencyModal/DeliveryFrequencyModal';
import { withDeliveryFrequencyModalProps } from 'viewModel/globalModals//deliveryFrequencyModal/withDeliveryFrequencyModalProps';

const ConnectedDeliveryFrequencyModal = withDeliveryFrequencyModalProps(DeliveryFrequencyModal);

export default ConnectedDeliveryFrequencyModal;
